import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "~env";
import { MemberInsuranceStatus, PaymentResultModelView, SelectedPremiumInfo, SubscriptionNoticePreselection } from "./subscription.model";

@Injectable({
  providedIn: "root",
})
export class SubscriptionCommandService {
  
  private COMMAND_API = environment.farpCommandApi;
  private REGISTRAR_COMMAND_API = environment.registrarCommandApi;
  constructor(
    private http: HttpClient
  ) {}
  
  proceedSubscriptionPayment(selectedPremiumInfo: SelectedPremiumInfo):
  Observable<PaymentResultModelView> {
    selectedPremiumInfo.requestDate = (new Date()).toISOString();
    const url = `${this.COMMAND_API}/payment/subscription/${selectedPremiumInfo.memberId}/payment`;
    return this.http.post<PaymentResultModelView>(url, selectedPremiumInfo );
  }
  addMemberInsuranceStatus(
    memberId: string,
    insuranceStatus: MemberInsuranceStatus,
  ){
    const URL = `${this.REGISTRAR_COMMAND_API}/member/${memberId}/insurance-status/addPortal`;
    const data = new FormData();
    data.append('insuranceStatusCodeId', insuranceStatus.insuranceStatusCodeId);
    data.append('effectiveOn', JSON.stringify(insuranceStatus.effectiveOn));
    return this.http
      .post<any>(URL, data);
  }
  reportReclamationValidation(memberId: string, financialYear: number, isReclamationReported: boolean, 
        surplusPremiumId: string, subscriptionNoticeId: string): Observable<SubscriptionNoticePreselection> {
    const subscriptionPreselection = {
      financialYear: financialYear,
      surplusPremiumId: surplusPremiumId,
      subscriptionNoticeId: subscriptionNoticeId
    }; 
    if (isReclamationReported) {
        const url = `${this.COMMAND_API}/subscription/${memberId}/SetWithNonReportedReclamationTrue`;
        return this.http.post<SubscriptionNoticePreselection>(url, subscriptionPreselection )
                 .pipe(map((res) => this.parseSubscriptionNoticePreselection(res, isReclamationReported)));
    } else {
      const url = `${this.COMMAND_API}/subscription/${memberId}/SetWithNonReportedReclamationFalse`;
      return this.http.post<SubscriptionNoticePreselection>(url, subscriptionPreselection )
                    .pipe(map((res) => this.parseSubscriptionNoticePreselection(res, isReclamationReported)));
    }  
  }

  private parseSubscriptionNoticePreselection(item: any, isReclamationReported: boolean): SubscriptionNoticePreselection {
    return {
      ...item.content,
      isReclamationReported: isReclamationReported
    };
  }
}
